import i18n from '../i18n';

export interface CameraMessageResources {
  Camera_Page_Title: string;
  Camera_Label_WaitingCameraPermission: string;
  Camera_Label_WaitingCameraPermissionDescription: string;
  Camera_Label_ChangeSetting: string;
  Camera_Label_Searching: string;
  Camera_Label_ProDialog1stQRCode: string;
  Camera_Label_ProDialog1stQRCodeDescription: string;
  Camera_Label_Pro2ndQRCodeRead: string;
  Camera_Label_Pro3rdQRCodeRead: string;
  Camera_Label_Pro4thQRCodeRead: string;
  Cmn_Dialog_Button_Ok: string;
  Cmn_Dialog_Button_Close: string;
}

export interface PhotoLibraryMessageResources {
  PhotoLibrary_Page_Title: string;
  PhotoLibrary_Label_WaitingPhotoLibraryPermission: string;
  PhotoLibrary_Label_WaitingPhotoLibraryPermissionDescription: string;
  PhotoLibrary_Label_ChangeSetting: string;
  PhotoLibrary_Label_Notice: string;
  PhotoLibrary_Label_SelectPhoto: string;
  PhotoLibrary_Label_ProDialog1stQRCode: string;
  PhotoLibrary_Label_ProDialog1stQRCodeDescription: string;
  PhotoLibrary_Label_Pro2ndQRCodeRead: string;
  PhotoLibrary_Label_Pro3rdQRCodeRead: string;
  PhotoLibrary_Label_Pro4thQRCodeRead: string;
  Cmn_Dialog_Button_Ok: string;
  Cmn_Dialog_Button_Close: string;
}

const cameraMessages = {
  Camera_Page_Title: 'camera_page_title',
  Camera_Label_WaitingCameraPermission: 'label_waiting_camera_permission1',
  Camera_Label_WaitingCameraPermissionDescription: 'label_waiting_camera_permission2',
  Camera_Label_ChangeSetting: 'label_change_setting',
  Camera_Label_Searching: 'label_searching',
  Camera_Label_ProDialog1stQRCode: 'label_pro_dialog_1st_qr',
  Camera_Label_ProDialog1stQRCodeDescription: 'label_pro_dialog_1st_qr_description',
  Camera_Label_Pro2ndQRCodeRead: 'label_pro_dialog_2nd_qr_read',
  Camera_Label_Pro3rdQRCodeRead: 'label_pro_dialog_3rd_qr_read',
  Camera_Label_Pro4thQRCodeRead: 'label_pro_dialog_4th_qr_read',
  Cmn_Dialog_Button_Ok: 'label_pro_dialog_ok',
  Cmn_Dialog_Button_Close: 'label_pro_dialog_close'
};

const photoLibraryMessages = {
  PhotoLibrary_Page_Title: 'photo_lib_page_title',
  PhotoLibrary_Label_WaitingPhotoLibraryPermission: 'label_waiting_photo_lib_permission1',
  PhotoLibrary_Label_WaitingPhotoLibraryPermissionDescription:
    'label_waiting_photo_lib_permission2',
  PhotoLibrary_Label_ChangeSetting: 'label_photo_lib_change_setting',
  PhotoLibrary_Label_Header: 'label_photo_header',
  PhotoLibrary_Label_Notice: 'label_photo_notice',
  PhotoLibrary_Label_SelectPhoto: 'label_select_photo',
  PhotoLibrary_Label_ProDialog1stQRCode: 'label_pro_dialog_1st_qr_photo',
  PhotoLibrary_Label_ProDialog1stQRCodeDescription: 'label_pro_dialog_1st_qr_description_photo',
  PhotoLibrary_Label_Pro2ndQRCodeRead: 'label_pro_dialog_2nd_qr_read_photo',
  PhotoLibrary_Label_Pro3rdQRCodeRead: 'label_pro_dialog_3rd_qr_read_photo',
  PhotoLibrary_Label_Pro4thQRCodeRead: 'label_pro_dialog_4th_qr_read_photo',
  Cmn_Dialog_Button_Ok: 'label_pro_dialog_ok',
  Cmn_Dialog_Button_Close: 'label_pro_dialog_close',
  Error_Dialog_Message_Multiple_Error: 'error_multiple_qr_in_photo',
  Error_Dialog_Message_Unknown_Error: 'error_unknown'
};

export const getCameraMessageResources = (): CameraMessageResources => {
  const result: any = {};
  for (const [k, v] of Object.entries(cameraMessages)) {
    result[k] = i18n.t(`coral:${v}`);
  }

  return result as CameraMessageResources;
};

export const getPhotoLibraryMessageResources = (): PhotoLibraryMessageResources => {
  const result: any = {};
  for (const [k, v] of Object.entries(photoLibraryMessages)) {
    result[k] = i18n.t(`coral:${v}`);
  }

  return result as PhotoLibraryMessageResources;
};
